<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="MENU LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          class="icon-pencil1"
          :id="tableRow.id"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="828px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-card shadow="never">
        <el-form ref="form" :model="form" :rules="rules" labelPosition="top">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Position" prop="pids">
                <el-cascader
                  v-model="form.pids"
                  style="width: 100%"
                  :props="{
                    label: 'name',
                    value: 'id',
                    children: 'children',
                    checkStrictly: true,
                  }"
                  :options="positionList"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Type" prop="type">
                <el-select v-model="form.type" style="width: 100%">
                  <el-option :value="1" label="Menu"></el-option>
                  <el-option :value="2" label="Button"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Menu Name" prop="name">
                <el-input style="width: 100%" v-model="form.name" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Address" prop="url">
                <el-input style="width: 100%" v-model="form.url" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Order" prop="order">
                <el-input style="width: 100%" v-model="form.order" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Visible or Not" prop="display">
                <el-select style="width: 100%" v-model="form.display">
                  <el-option :value="1" label="visible"></el-option>
                  <el-option :value="2" label="invisible"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Icon" prop="icon">
                <el-input style="width: 100%" v-model="form.icon" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="visible = false"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { removeItem, updateAndAddMenu, getTableData } from './api'

import { getMenuList } from '../api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Menu Name',
        type: 'input',
        key: 'name',
      },
    ]
    const tableModel = [
      {
        width: 250,
        label: 'Menu Name',
        prop: 'name',
      },
      {
        Width: 170,
        label: 'Address',
        prop: 'url',
      },
      {
        width: 170,
        label: 'Type',
        prop: 'typeStr',
      },
      {
        width: 230,
        label: 'Action',
        slotName: 'action',
      },
    ]
    return {
      popoverVisible: false,
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        pids: [],
        type: '',
        name: '',
        url: '',
        order: '',
        display: '',
        icon: '',
      },
      rules: {
        type: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        name: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        url: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        order: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        display: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      positionList: [],
      isTableLoading: true,
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    async _getPositionList() {
      try {
        this.positionList = await getMenuList()
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async handleRemoveItem(id) {
      this.isTableLoading = true
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
    },
    async handleSaveBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const submitData = { ...this.form, id: this.formId || '' }
        const pids = submitData.pids
        if (pids?.length) {
          submitData.pid = pids[pids.length - 1]
          submitData.pids = JSON.stringify([...submitData.pids])
        } else {
          submitData.pids = '[]'
          submitData.pid = ''
        }
        await this.updateAndAdd(submitData)
      }
    },
    async updateAndAdd(params) {
      try {
        await updateAndAddMenu(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      await this._getPositionList()
      this.visible = true
    },
    async handleEdit({ row }) {
      this.formId = row.id
      await this._getPositionList()
      this.visible = true

      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => {
          if (key === 'pids') {
            this.form[key] = JSON.parse(row[key])
          } else {
            this.form[key] = row[key]
          }
        })
      })
    },
  },
}
</script>
